import { useEffect, useRef } from 'react';
import Artplayer from 'artplayer';
import id from 'artplayer/dist/i18n/id.js';
import es from 'artplayer/dist/i18n/es';

export default function Player({ option, getInstance, ...rest }) {
    const artRef = useRef();

    useEffect(() => {
        const art = new Artplayer({
            ...option,
            container: artRef.current,
            i18n: { 
                id: id,
                'es': es,
            },
            lang: 'es',
        });

        if (getInstance && typeof getInstance === 'function') {
            getInstance(art);
        }

        return () => {
            if (art && art.destroy) {
                art.destroy(false);
            }
        };
    }, []);

    return <div ref={artRef} {...rest}></div>;
}